module.exports = __webpack_public_path__ + "img/white-bg-pattern.jpg";